var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExperiences(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    color: "#fff",
    width: "470px",
    height: "470px",
    viewBox: "0 0 470 470",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD",
    transform: "translate(-503.000000, -292.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(503.000000, 292.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "to-fill",
    id: "Rectangle",
    fill: "#220BAB",
    x: 0,
    y: 0,
    width: 470,
    height: 470,
    rx: 20
  }), /*#__PURE__*/React.createElement("text", {
    className: "to-color",
    id: "D\\xE9veloppeur-Web-/-Re",
    fontFamily: "Plus Jakarta Sans",
    fontSize: 50,
    fontWeight: "bold",
    "line-spacing": 70,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 57,
    y: 180
  }, "D\xE9veloppeur"), /*#__PURE__*/React.createElement("tspan", {
    x: 57,
    y: 250
  }, "Web / React"), /*#__PURE__*/React.createElement("tspan", {
    x: 57,
    y: 320
  }, "- Node")), /*#__PURE__*/React.createElement("text", {
    className: "to-color",
    id: "see-all-experiences",
    fontFamily: " Plus Jakarta Sans",
    fontSize: 18,
    fontWeight: 400,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 250,
    y: 441
  }, "see all experiences")), /*#__PURE__*/React.createElement("g", {
    id: "arrow-right",
    transform: "translate(423.000000, 428.000000)",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,8 L16,8",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "8 0 16 8 8 16"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperiences);
export default __webpack_public_path__ + "static/media/experiences.339211f4a73a057435b360038dd402d4.svg";
export { ForwardRef as ReactComponent };